import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { fetchWeddingData } from 'apollo/projects.query';

import { Loading } from 'components/Loading';
import HorizontalMenu from 'components/Menus/HorizontalMenu';
import ProjectsSettingsDetails from './ProjectsSettings.Details';
import ProjectsSettingsNotifications from './ProjectsSettings.Notifications';
import './styles.scss';

const ProjectSettings = ({
  type = 1,
  weddingId,
  updateWeddingChanges,
  pushNotification,
  projectCreateStartCallback,
  projectCreatedCallback,
  projectCreatedErrorCallback,
  formData: _formData,
}) => {
  const [projectSettingsType, setProjectSettingsType] = useState(0);
  const [formData, setFormData] = useState(_formData ?? null);

  const userInfo = useSelector((state) => state.global.userInfo);
  const userOrgId = userInfo?.orgId || userInfo?.organization?.id;
  const projectOrgId = formData?.organizationId;
  const isClient = projectOrgId != null && userOrgId !== projectOrgId;

  useEffect(() => {
    const getWeddingData = async () => {
      const data = await fetchWeddingData({ id: weddingId });

      if (data.wedding) {
        setFormData(data.wedding);
      }
    };
    if (weddingId !== null && projectSettingsType === 0) {
      getWeddingData();
    }
  }, [weddingId, projectSettingsType]);

  // Automatically switch to notifications tab if client can't access details
  useEffect(() => {
    if (weddingId && isClient && projectSettingsType === 0) {
      setProjectSettingsType(1);
    }
  }, [weddingId, isClient, projectSettingsType]);

  const items = [
    {
      id: 'details',
      name: (<><span className="visually-hidden--mobile">Project</span> Details</>),
      onClick: () => setProjectSettingsType(0),
      active: projectSettingsType === 0,
    },
    {
      id: 'notifications',
      name: 'Notifications',
      onClick: () => setProjectSettingsType(1),
      active: projectSettingsType === 1,
    },
  ].filter(item => {
    // Hide "Project Details" tab if user is a client
    if (item.id === 'details' && isClient) {
      return false;
    }
    return true;
  });

  if (weddingId && !formData) {
    return (
      <Loading />
    );
  }

  return (
    <>
      {weddingId && (
        <HorizontalMenu
          items={items}
        />
      )}
      {projectSettingsType === 0 && !isClient && (
        <ProjectsSettingsDetails
          type={type}
          weddingId={weddingId}
          formData={formData}
          projectCreateStartCallback={projectCreateStartCallback}
          projectCreatedCallback={projectCreatedCallback}
          projectCreatedErrorCallback={projectCreatedErrorCallback}
          updateWeddingChanges={updateWeddingChanges}
          pushNotification={pushNotification}
        />
      )}
      {projectSettingsType === 1 && (
        <ProjectsSettingsNotifications
          id={weddingId}
          pushNotification={pushNotification}
        />
      )}
    </>
  );
};

ProjectSettings.propTypes = {
  type: PropTypes.number,
};

ProjectSettings.defaultProps = {};

export default ProjectSettings;
